import React from 'react';
import Form from './Form'

const Contact = () => {
    return (

        <section className="our-event" id="theEvent">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 align-self-center">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="item">
                                    <h3>Join the waiting list</h3>
                                    <p>Distillery viral photo booth literally williamsburg semiotics iceland. Kinfolk pug sustainable
                                        flannel keffiyeh messenger bag aesthetic craft beer coloring book. Flannel lyft hella, blue bottle
                                        kombucha copper mug tbh yuccie irony. Coloring book vegan vape unicorn yr, single-origin coffee
                                        listicle mustache beard whatever 3 wolf moon disrupt pinterest scenester.</p>
                                    <Form />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    
    );
};

export default Contact;